import { KeyboardEvent as ReactKeyboardEvent } from 'react';

import { KeyCodes } from './types';

type Hotkey = (e: KeyboardEvent | ReactKeyboardEvent, key?: string) => boolean;

const { minus, equal, digit0, numpadAdd, numpadSubtract } = KeyCodes;

const isMetaKey: Hotkey = e => e.metaKey || e.ctrlKey;
const isAltKey: Hotkey = e => e.altKey;
const isShiftKey: Hotkey = e => e.shiftKey;

const isWithMeta = (e: KeyboardEvent | ReactKeyboardEvent, key: KeyCodes) => isMetaKey(e) && !isAltKey(e) && !isShiftKey(e) && e.code === key;

export const isZoomInEvent: Hotkey = e => isWithMeta(e, equal) || isWithMeta(e, numpadAdd);

export const isZoomOutEvent: Hotkey = e => isWithMeta(e, minus) || isWithMeta(e, numpadSubtract);
export const isZoomResetEvent: Hotkey = e => isWithMeta(e, digit0);
